import { Component } from '@angular/core';
import { SupplierService } from '../supplier.service';
import { Supplier } from '../supplier';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../../shared/notification.service';

@Component({
  selector: 'app-supplier-edit',
  templateUrl: 'edit.component.html',
})
export class SupplierEditComponent {
  /**
   * Details of the supplier being edited.
   */
  public supplier: Supplier;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {SupplierService} supplierService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private supplierService: SupplierService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.supplierService.loading.subscribe(result => (this.isLoading = result));
    this.route.params.subscribe(params => this.loadSupplier(params.id));
  }

  /**
   * Perform the edit action which send the edited supplier to the backend.
   */
  public edit() {
    const editSupplier = this.supplierService
      .updateSupplier(this.supplier.id, this.supplier)
      .subscribe(
        (result: Supplier) => {
          this.notificationService.success(
            `Supplier Updated`,
            `The supplier ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.supplier = new Supplier();
          editSupplier.unsubscribe();
          this.router.navigate(['/suppliers']);
        },
        err => {
          this.notificationService.error(
            `Supplier Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/suppliers']);
        },
      );
  }

  /**
   * Loads the requested supplier so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadSupplier(id: string) {
    this.supplierService.findSupplier(id).subscribe(
      result => {
        this.supplier = result;
      },
      err => {
        this.notificationService.error(
          `Supplier Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/suppliers']);
      },
    );
  }
}
